export default __webpack_public_path__ + "static/havant-4-e0d1183937822d5a532ba14a32a1ecb3.jpg";